export const SUBJECT_TYPE_OPTIONS = [
  { value: "person", label: "Person" },
  { value: "pet", label: "Pet" },
];

export const AGE_GROUP_OPTIONS = [
  { value: "infant", label: "Infant" },
  { value: "toddler", label: "Toddler" },
  { value: "child", label: "Child" },
  { value: "teen", label: "Teen" },
  { value: "adult", label: "Adult" },
  { value: "older_adult", label: "Older adult" },
  { value: "pet", label: "Pet" },
];

export const TRACKING_FOCUS_OPTIONS = [
  { code: "BEHAVIOR", label: "Behavior" },
  { code: "MEDICATION", label: "Medication" },
  { code: "SLEEP", label: "Sleep" },
  { code: "FOOD_APPETITE", label: "Food / appetite" },
  { code: "MOOD", label: "Mood" },
  { code: "SENSORY", label: "Sensory" },
  { code: "SCHOOL", label: "School" },
  { code: "HEALTH", label: "Health" },
  { code: "SEIZURES", label: "Seizures" },
  { code: "PAIN", label: "Pain" },
  { code: "MOBILITY", label: "Mobility" },
  { code: "TOILETING_HYGIENE", label: "Toileting / hygiene" },
  { code: "THERAPIES", label: "Therapies" },
  { code: "APPOINTMENTS", label: "Appointments" },
  { code: "ROUTINES", label: "Daily routines" },
];

export const CARE_SETTING_OPTIONS = [
  { code: "HOME", label: "Home" },
  { code: "SCHOOL", label: "School" },
  { code: "DAYCARE", label: "Daycare" },
  { code: "THERAPY", label: "Therapy" },
  { code: "MEDICAL", label: "Medical care" },
  { code: "SHARED_HOUSEHOLDS", label: "Shared households" },
  { code: "RESIDENTIAL", label: "Residential care" },
  { code: "HOSPICE", label: "Hospice / palliative care" },
  { code: "TRAVEL", label: "Travel / outings" },
];
